import styled from 'styled-components/macro';

export const PresetsWrapper = styled.div`
    position: relative;
    margin-left: auto;
`;
